module.exports = __webpack_public_path__ + "static/media/izlozba (7).521867a2.jpg";